module.exports = function(cb) {
  if (window.indexedDB) {
    try {
      var request = window.indexedDB.open('test');
      request.onerror = function (evt) {
        if (request.error) {
          evt.preventDefault();
          cb(request.error.name === 'InvalidStateError');
        }
      };
      request.onsuccess = function () {
        cb(false);
      };
    } catch (e) {
      cb(false);
    }
  }
};



//////////////////
// WEBPACK FOOTER
// ./lib/funnel/incognito/gecko.js
// module id = 20
// module chunks = 1 3